import { usePublicLang } from "@/contexts/PublicLangContext";
import { getEffectivePricingDisplay } from "@/lib/pricingUtils";
import { LANDING } from "@/constants/testIds";
import ScrollReveal from "./ScrollReveal";

/** Bloque destacado (inmediatamente debajo del hero) para que una paciente
 * nueva encuentre de inmediato donde reservar su consulta de valoración,
 * una paciente recurrente su control post-tratamiento, o alguien interesada
 * se sume a una convocatoria de modelo (Fix E, 2026-09-09). */
export default function FeaturedBookingSection({ services, onBook }) {
  const { t } = usePublicLang();
  if (!services || services.length === 0) return null;

  const copyFor = (kind) => {
    if (kind === "model") return { badge: t("landing.featured.modelTitle"), cta: t("landing.featured.modelCta") };
    if (kind === "review") return { badge: t("landing.featured.returning"), cta: t("landing.featured.reviewCta") };
    return { badge: t("landing.featured.firstTime"), cta: t("landing.featured.consultationCta") };
  };

  return (
    <section className="px-5 py-8 -mt-6 sm:-mt-10 relative z-10" data-testid={LANDING.featuredBookingSection}>
      <ScrollReveal>
        <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-lg border border-black/5 p-5 sm:p-6 grid gap-3 sm:grid-cols-2">
          {services.map((s) => {
            const copy = copyFor(s.service_kind);
            const pricingDisplay = getEffectivePricingDisplay(s);
            return (
              <button
                key={s.id}
                type="button"
                onClick={() => onBook(s.id)}
                className="text-left rounded-xl border border-[var(--brand-primary)]/20 bg-[var(--brand-secondary)]/40 hover:border-[var(--brand-primary)] hover:shadow-sm transition-all p-4"
                data-testid={`${LANDING.featuredBookingCardPrefix}${s.id}`}
              >
                <p className="text-xs font-semibold uppercase tracking-wide text-[var(--brand-primary)]">
                  {copy.badge}
                </p>
                <p className="font-serif text-lg text-[#292522] mt-1">
                  {copy.cta}
                </p>
                <p className="text-sm text-[#6B6058] mt-1">{s.name} · {pricingDisplay.regularText}</p>
              </button>
            );
          })}
        </div>
      </ScrollReveal>
    </section>
  );
}
